import React from "react";
import ReactDom from 'react-dom';
import OrderCheckout from "./OrderCheckout";

let els = document.querySelectorAll('.order-checkout-react');

els.forEach(el => {
    ReactDom.render(<OrderCheckout/>, el);
});